const state = {
  userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {},
  month: new Date().getMonth() + 1,
  year: new Date().getFullYear(),
  startMonth: new Date().getMonth() + 1,
  startYear: new Date().getFullYear() - 3
}
const mutations = {
    // 后台
  SET_USER: (state, userInfo) => {
    state.userInfo = userInfo;
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};